import {
    Col,
    Layout,
    Nav,
    Row,
    Space,
    Typography,
    Spin,
    Tooltip,
    Avatar,
    Tag, Toast, Anchor, Descriptions, Calendar, DatePicker
} from '@douyinfe/semi-ui';
import {
    IconFolderOpen,
    IconFile,
    IconGithubLogo,
    IconPlus,
    IconCheckboxIndeterminate,
    IconAlignJustify, IconList, IconMenu, IconInfoCircle
} from '@douyinfe/semi-icons';
import {createContext, useEffect, useState} from 'react';
import axios from 'axios';
import {MarkdownRender} from './libs/MarkdownRender';
import {Link, useParams} from 'react-router-dom';
import {MobileApp} from './pages/MobileApp';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import {DatePickerL, CalendarL, DescriptionsL, ContentRight} from './libs/CalendarAndDatePicker';

export const MenuContext = createContext({})

/**
 * Logo组件，用作自定义Logo
 * 
 * @param {object} config 自定义配置对象
 * @returns 
 */
export function Logo ({config}) {
    
    const { Title, Text } = Typography
    
    // 复制文本的函数
    const copy = text => {
        navigator.clipboard.writeText(text)
            .then(res => {
                console.log(res)
                Toast.success('Copied!')
            })
            .catch(err => {
                Toast.error(err)
            })
           
    }
    
    return (
        <Space vertical style={{height: '100%', width: '100%'}} spacing={2}>
            <Row style={{height: '60%'}}>
                <Col span={24}>
                    <a href={'/'}>
                        <Avatar
                            src={config?.logo}
                            size={'extra-large'}
                        />
                    </a>
                </Col>
            </Row>
            <Row style={{height: '20%'}}>
                <Col>
                    <Title >{config?.username || '未获取到用户名'}</Title>
                </Col>
            </Row>
            { config?.email ? (
                <Row>
                    <Col>
                        <Tooltip content={'点击复制'} position={'right'}>
                            <Text onClick={() => copy(config?.email)} style={{cursor: 'pointer'}}> {config?.email} </Text>
                        </Tooltip>
                    </Col>
                </Row>
            ) : <></> }
            <Row style={{height: '20%'}}>
                <Col style={{height: '100%'}}>
                    <Space style={{width: '100%', height: '100%', overflow: 'auto', justifyContent: 'center'}} wrap >
                        {
                            // links数组可以存放多个对象，通过遍历数组生成对应link组件
                            // 如果单个对象有src字段，则通过Avatar渲染成icon
                            config?.links?.map(item => {
                                const info = item?.src ? <Avatar shape='square' style={{height: 15, width: 'auto'}} src={item?.src} alt={config?.title} /> : <>{item?.title?.match(/(github)/gi) ? <IconGithubLogo /> : null}<Text strong> {item?.title} </Text></>
                                return (
                                    <>
                                        <Tag color='grey' type="light" style={{cursor: 'pointer'}} onClick={() => window.open(item?.url)}>
                                            <Space spacing={5}>
                                                {info}
                                            </Space>
                                        </Tag>
                                    </>
                                )
                            })
                        }
                    </Space>
                </Col>
            </Row>
        </Space>
    )
}

/**
 * 左侧导航栏动态组件
 * 通过递归生成嵌套的导航栏组件
 * 
 * @param {object} data 
 * @returns 
 */
export function DirectoryTree({ data, index, tooltips='right' }) {
    return (
        <>
            {
                data.type === 'directory' && (
                    <Nav.Sub
                        level={index}
                        itemKey={data.path}
                        text={data.name}
                        type={data.type}
                        icon={<IconFolderOpen />}
                    >
                        {
                            data?.children?.map( child => {
                                return <DirectoryTree data={child} index={index+1} />
                            } )
                        }
                    </Nav.Sub>
                )
            }
            {
                data.type === 'file' && (
                    <Tooltip content={data.name.replace(/.md/g, '')} position={tooltips}>
                        <Nav.Item icon={<IconFile />} level={index} itemKey={data.path} text={data.name.replace(/.md/g, '')} type={data.type} />
                    </Tooltip>
                )
            }
        </>
    );
}


function App() {
    
    const { Content, Sider } = Layout
    const collapseStats = [
        {collapseText: '收起', collapseIcon: click => <IconCheckboxIndeterminate onClick={click} style={{cursor: 'pointer', color: 'rgba(var(--semi-blue-5), 1)'}} />, listText: '关闭', listIcon: click => <IconMenu onClick={click} style={{cursor: 'pointer', color: 'rgba(var(--semi-blue-5), 1)'}} />},
        {collapseText: '展开', collapseIcon: click => <IconPlus onClick={click} style={{cursor: 'pointer', color: 'rgba(var(--semi-blue-5), 1)'}} />, listText: '开启', listIcon: click => <IconList onClick={click} style={{cursor: 'pointer', color: 'rgba(var(--semi-blue-5), 1)'}} />}
    ]
    
    const [blogList, setBlogList] = useState([])
    const [selectedKey, setSelectKey] = useState('')
    const [contentLoading, setContentLoading] = useState(false)
    const [openKeys, setOpenKeys] = useState([])
    const [markdown, setMarkdown] = useState('')
    const [userinfo, setUserinfo] = useState({})
    const [menus, setMenus] = useState([])
    const [menuLoading, setMentLoading] = useState(false)
    const [autoCollapse, setAutoCollapse] = useState(false)
    const [showListNumber, setShowListNumber] = useState(true)
    
    
    const params = useParams()
    
    useEffect(() => {
        axios.get('https://wongjinggitt.github.io/config/blog_list.json')
            .then(res => {
                setBlogList(res.data?.children)
                if (params['*']) {
                    const link = `${params['*']}.md`
                    let opens = link.split(/\/|\\/g)
                    opens = opens.slice(0, opens.length - 1)
                    opens = opens.map((_, index, array) => array.slice(0, index + 1).join('\\'))
                    setSelectKey(link)
                    setOpenKeys([...openKeys, ...opens])
                }
            });
        axios.get('https://wongjinggitt.github.io/config/config.json')
            .then(res => {
                setUserinfo(res.data)
                // eslint-disable-next-line no-unused-expressions
                document.title = `${res.data?.username}的个人博客`
            })
        
        let collapse = window.localStorage.getItem('autoCollapse')
        let listNumber = window.localStorage.getItem('showListNumber')
        if (collapse) {
            setAutoCollapse(Boolean(Number(collapse)))
        }
        if (listNumber) {
            setShowListNumber(Boolean(Number(listNumber)))
        }
    }, [])

    useEffect(() => {
        if (selectedKey !== '') {
            setContentLoading(true)
            setMentLoading(true)
            const timestamp = new Date().getTime();
            axios.get(`https://wongjinggitt.github.io/blog/${selectedKey}?timestamp=${timestamp}`)
                .then(res => {
                    setMarkdown(res.data)
                })
                .catch(reason => {
                    setMarkdown('- # 博客不存在')
                })
                .finally(() => {
                    setContentLoading(false)
                })
        }
    }, [selectedKey])
    
    useEffect(() => {
        setMentLoading(false)
    }, [menus])
    
    const isMobileDriver = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)
    
    function parseDataToComponent(data) {
        if (Array.isArray(data) && data.length > 0) {
            return data.map(item => (
                <Anchor.Link
                    href={`#${item.id}`}
                    title={
                        <>
                            <Descriptions>
                                <Descriptions.Item itemKey={showListNumber && item?.key}>{item.text}</Descriptions.Item>
                            </Descriptions>
                        </>
                    }
                >
                    {parseDataToComponent(item.children)}
                </Anchor.Link>
            ));
        }
        return null;
    }
    
    return (
        isMobileDriver() ? <MobileApp config={userinfo} /> : (
            <Layout
                style={{height: '100vh'}}
            >
                <Sider
                    style={{height: '100%'}}
                >
                    <Nav
                        renderWrapper={({ itemElement, isSubNav, isInSubNav, props }) => {
                            if (isSubNav) return itemElement
                            return <Link to={props.itemKey.replace(/.md/g, '')} style={{ textDecoration: "none" }} > {itemElement} </Link>
                        }}
                        limitIndent={false}
                        style={{ height: '100%', width: 300 }}
                        bodyStyle={{overflow: 'auto', height: '65%'}}
                        selectedKeys={[selectedKey]}
                        openKeys={openKeys}
                        onSelect={data => {
                            setSelectKey(data.itemKey)
                        }}
                        onOpenChange={item => setOpenKeys(item.openKeys)}
                        footer={
                            <Row style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
                                <Col span={4} style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    <Tooltip content={`默认${collapseStats.at(autoCollapse).collapseText}文章目录，点击${collapseStats.at(!autoCollapse).collapseText}`}>
                                        {
                                            collapseStats.at(autoCollapse).collapseIcon(
                                                () => {
                                                    setAutoCollapse(!autoCollapse)
                                                    window.localStorage.setItem('autoCollapse', String(Number(!autoCollapse)))
                                                }
                                            )
                                        }
                                    </Tooltip>
                                </Col>
                                <Col span={4} style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    <Tooltip content={`默认${collapseStats.at(showListNumber).listText}目录序号，点击${collapseStats.at(!showListNumber).listText}`}>
                                        {
                                            collapseStats.at(showListNumber).listIcon(
                                                () => {
                                                    setShowListNumber(!showListNumber)
                                                    window.localStorage.setItem('showListNumber', String(Number(!showListNumber)))
                                                }
                                            )
                                        }
                                    </Tooltip>
                                </Col>
                                <Col span={4} style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    <Tooltip content={'此处的更改只对本地有效'}>
                                        <IconInfoCircle/>
                                    </Tooltip>
                                </Col>
                            </Row>
                        }
                    >
                        <Nav.Header
                            style={{ padding: '0px 8px 0px 5.5px', height: '30%' }}
                            children={userinfo.username ? <Logo config={userinfo} /> : <></>}
                        />
                        {
                            blogList?.map( data => <DirectoryTree tooltips={true} data={data} index={0} /> )
                        }
                    </Nav>
                </Sider>
                <Content>
                        <Row style={{height: '100%', width: '100%'}}>
                            <Col span={6} style={{height: '100%', overflowY: 'auto', backgroundColor: 'rgba(var(--semi-grey-0), 1)'}}>
                                {
                                    menuLoading ? (
                                        <Spin style={{marginLeft: '30%', marginTop: '10%'}} />
                                    ) : (
                                        <Anchor
                                            autoCollapse={!autoCollapse}
                                            getContainer={() => document.getElementById('markdown-col')}
                                            maxWidth={'100%'}
                                            maxHeight={'100%'}
                                            offsetTop={10}
                                            showTooltip
                                            scrollMotion
                                            targetOffset={10}
                                            position={'right'}
                                        >
                                            {parseDataToComponent(menus)}
                                        </Anchor>
                                    )
                                }
                            </Col>
                            <Col span={12} style={{overflowY: 'auto', maxWidth: '100%', maxHeight: '100%'}} id={'markdown-col'}>
                                {
                                    contentLoading ? (
                                        <Spin style={{marginLeft: '50%', marginTop: '50%'}}/>
                                    ) : (
                                        <MenuContext.Provider value={{menus, setMenus}}>
                                            <MarkdownRender markdown={markdown}/>
                                        </MenuContext.Provider>
                                    )
                                }
                            </Col>
                            {/* TODO: 这里因为日历组件直接写在了APP组件根目录，导致每次点击会重新渲染整个APP组件，造成卡顿 */}
                            <Col span={6} style={{overflowY: 'auto', maxWidth: '100%', height: '100%', backgroundColor: 'rgba(var(--semi-grey-0), 1)'}}>
                                <ContentRight />
                            </Col>
                        </Row>
                </Content>
            </Layout>
        )
    )
}

export default App;
